/* global axios */
import ApiClient from './ApiClient';

const getTimeOffset = () => -new Date().getTimezoneOffset() / 60;

class ManagementChartsAPI extends ApiClient {
  constructor() {
    super('management_charts', { accountScoped: false });
  }

  getDailyAttendanceByHour({ from, to }) {
    return axios.get(`${this.url}/daily_attendance_by_hour`, {
      params: {
        since: from,
        until: to,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  getTotalServiceTime({
    from,
    to,
    groupByAccount,
    assigneeId,
    accountId = null,
  }) {
    return axios.get(`${this.url}/total_service_time`, {
      params: {
        since: from,
        until: to,
        group_by_account: groupByAccount,
        assignee_id: assigneeId,
        account_id: accountId,
        timezone_offset: getTimeOffset(),
      },
    });
  }
}

export default new ManagementChartsAPI();
